import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import type { SxProps, Theme } from '@mui/material/styles'
import { IFR_RESERVE_MINUTES, VFR_RESERVE_MINUTES } from './usePlanDraft'

// VFR or IFR: sets the final reserve the fuel plan uses. One is always on.
export default function FlightRulesToggle({
  reserveMinutes,
  onReserve,
  sx,
}: {
  reserveMinutes: number
  onReserve: (n: number) => void
  sx?: SxProps<Theme>
}) {
  return (
    <ToggleButtonGroup
      exclusive
      fullWidth
      size="small"
      value={reserveMinutes === IFR_RESERVE_MINUTES ? 'ifr' : 'vfr'}
      onChange={(_, value: 'vfr' | 'ifr' | null) => value && onReserve(value === 'ifr' ? IFR_RESERVE_MINUTES : VFR_RESERVE_MINUTES)}
      sx={sx}
    >
      <ToggleButton value="vfr">VFR</ToggleButton>
      <ToggleButton value="ifr">IFR</ToggleButton>
    </ToggleButtonGroup>
  )
}
